import { useCallback } from "react";

import mapboxgl from "mapbox-gl";
import { useMapStore } from "stores/map";
import type { Envelope } from "stores/map";

import { panToCombinedNetworkBounds, panToNetworkBounds } from "./util";

export function useNetworkBoundsManager(mapbox: mapboxgl.Map) {
  const setNetworkEnvelope = useMapStore((s) => s.setNetworkEnvelope);
  const setSalesEnvelope = useMapStore((s) => s.setSalesEnvelope);
  const storedNetworkEnvelope = useMapStore((s) => s.networkEnvelope);
  const storedSalesEnvelope = useMapStore((s) => s.salesEnvelope);
  //takes in the envelopes produced by the two midstream well toggles
  //from the midstream navigator on the map and combines them to focus
  //map camera for both
  const panToFocusAreaBounds = useCallback(
    async (options?: {
      singlePadding?: number;
      combinedPadding?: number;
      duration?: number;
      networkEnvelope?: Envelope;
      salesEnvelope?: Envelope;
    }) => {
      const salesEnvelope = options?.salesEnvelope ?? storedSalesEnvelope;
      const networkEnvelope = options?.networkEnvelope ?? storedNetworkEnvelope;
      const envelopes = [salesEnvelope, networkEnvelope].filter(Boolean) as Envelope[];
      if (envelopes.length === 0) return;

      if (envelopes.length === 1) {
        await panToNetworkBounds("", [], mapbox, envelopes[0]);
      } else {
        await panToCombinedNetworkBounds(mapbox, envelopes, {
          padding: options?.combinedPadding ?? 75,
          duration: options?.duration ?? 3
        });
      }
    },
    [mapbox, storedNetworkEnvelope, storedSalesEnvelope]
  );

  return {
    storeNetworkEnvelope: setNetworkEnvelope,
    storeSalesEnvelope: setSalesEnvelope,
    panToFocusAreaBounds,
    clearEnvelopes: () => {
      setNetworkEnvelope(null);
      setSalesEnvelope(null);
    }
  };
}
